// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC38wOkm486hO8J3xndBOF1P3pZtCWNNCY",
    authDomain: "genix-53e27.firebaseapp.com",
    projectId: "genix-53e27",
    storageBucket: "genix-53e27.firebasestorage.app",
    messagingSenderId: "922000533147",
    appId: "1:922000533147:web:447899ef2ce59b8769083e",
};

const app = initializeApp(firebaseConfig, "genix"); // Her oyun için benzersiz bir isim
export const db6 = getFirestore(app);